import React from 'react'

import VScroll from '../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll'
import ItemTypeList from './item-type-list/item-type-list'
import QuickAdd_BreadcrumbNavigation from "../../layout/page-title/form-title-breadcrumb"
import {BreadcrumbElement} from "../../../../core/gd-components/breadcrumbs/breadcrumbs-custom"

type Props = {
    className?       : string

    breadcrumbItems? : BreadcrumbElement[]
    typeItems        : any[]

    onSelectType?    : callback
    onSelectItem?    : callback
    onUpgrade?       : callback
}

export default class QuickAdd_SelectTypeWithBreadcrumbs extends React.Component<Props> {

    render() {
        return (
            <div className={Classes("new-form-layout", this.props.className)}>
                <QuickAdd_BreadcrumbNavigation breadcrumbItems={this.props.breadcrumbItems}/>

                <VScroll className="quick-add-content m-t-35">
                    {_.map(this.props.typeItems, (group,key) => (
                        <ItemTypeList key           = {group.groupName+"_"+key}
                                      title         = {group.title}
                                      items         = {group.items}
                                      onSelect      = {this.props.onSelectType}
                                      onItemSelect  = {this.props.onSelectItem}
                                      onUpgrade     = {this.props.onUpgrade}/>
                    ))}
                </VScroll>
            </div>
        )
    }
}
